// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports

import {
  RoomModel,
  ProgramModel,
  ProjectModel,
  CategoryModel,
  DepartmentModel,
  RoomContentModel,
  MenuDto,
} from "@app/catalog";

export class MenuModel
{
  public rooms: WritableSignal<RoomModel[]>;
  public departments: WritableSignal<DepartmentModel[]>;
  public projects: WritableSignal<ProjectModel[]>;
  public programs: WritableSignal<ProgramModel[]>;
  public categories: WritableSignal<CategoryModel[]>;
  public roomContents: WritableSignal<RoomContentModel[]>;

  constructor()
  {
    this.rooms = signal<RoomModel[]>([]);
    this.departments = signal<DepartmentModel[]>([]);
    this.projects = signal<ProjectModel[]>([]);
    this.programs = signal<ProgramModel[]>([]);
    this.categories = signal<CategoryModel[]>([]);
    this.roomContents = signal<RoomContentModel[]>([]);
  }


  public static fromDto(dto: MenuDto): MenuModel
  {
    const model = new MenuModel();    
    model.rooms.set((dto?.rooms || []).map((x: any) => RoomModel.fromDto(x)));
    model.departments.set((dto?.departments || []).map((x: any) => DepartmentModel.fromDto(x)));
    model.projects.set((dto?.projects || []).map((x: any) => ProjectModel.fromDto(x)));
    model.programs.set((dto?.programs || []).map((x: any) => ProgramModel.fromDto(x)));
    model.categories.set((dto?.categories || []).map((x: any) => CategoryModel.fromDto(x)));
    model.roomContents.set((dto?.roomContents || []).map((x: any) => RoomContentModel.fromDto(x)));  
    return model;
  }
}
